import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleContentRoutingModule } from './article-content-routing.module';
import { ArticleContentFormComponent } from './components/article-content-form/article-content-form.component';
import { SharedModule } from '../shared/shared.module';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ArticleContentMergeConflictComponent } from './components/article-content-merge-conflict/article-content-merge-conflict.component';
import { SectionHeaderComponent } from '../shared/standalone/components/section-header/section-header.component';

@NgModule({
  declarations: [
    ArticleContentFormComponent,
    ArticleContentMergeConflictComponent
  ],
  imports: [
    CommonModule,
    ArticleContentRoutingModule,
    SharedModule,
    SharedFormSectionsModule,
    MatSnackBarModule,
    MatDialogModule,
    SectionHeaderComponent,
  ],
})
export class ArticleContentModule {}
